import { FhsAxios } from "../../services/axios";
import moment from "moment";
import { hasItBeenLoaded } from "@/helpers/loading";

export default {
  state: {
    transactionsList: null,
    dateRange: {
      // Значение по умолчанию - месяц от текущей даты
      beginDate: moment()
        .subtract(1, "months")
        .format("DD.MM.YYYY"),
      endDate: moment().format("DD.MM.YYYY")
    }
  },
  actions: {
    fetchTransactions({ commit, getters, state }) {
      commit("unsetTransactions");

      // Прерываем выполнение фукнции, если список уже загружен
      if (hasItBeenLoaded(state.transactionsList)) {
        return;
      }

      let url = "reports/cash-flows";
      // Если пользователь - VIP и пользователь выбрал определенного брокера, добавляем в запрос ID брокера (получаем данные только по выбранному брокеру)
      if (
        getters.selectedPortfolio !== "all" &&
        getters.selectedPortfolio !== undefined
      ) {
        url += "/" + getters.selectedPortfolio;
      }
      return new Promise((resolve, reject) => {
        FhsAxios.post(url, {
          bDate: state.dateRange.beginDate,
          eDate: state.dateRange.endDate
        })
          .then(response => {
            commit("setTransactionsList", response.data.result.data);
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    changeDateRange({ commit, dispatch }, dateRange) {
      // Показываем прелоадер
      commit("unsetTransactions");
      // Выставляем новый промежуток даты
      commit("setDateRange", dateRange);
      // Загружаем новые данные
      dispatch("fetchTransactions");
    }
  },
  mutations: {
    setTransactionsList(state, transactionsList) {
      state.transactionsList = transactionsList;
    },
    unsetTransactions(state) {
      state.transactionsList = null;
    },
    setDateRange(state, dateRange) {
      state.dateRange = {
        beginDate: dateRange[0],
        endDate: dateRange[1]
      };
    }
  },
  getters: {
    transactionsList(state) {
      // Если данные еще не подгрузились, возвращаем пустой массив
      return state.transactionsList === null ? [] : state.transactionsList;
    },
    isTransactionsListLoading(state) {
      return state.transactionsList === null;
    },
    transactionsDateRange(state) {
      return state.dateRange;
    }
  }
};
